<template>
  <div class="kvass-media-types-youtube-preview">
    <template v-if="!isValid">
      <Icon :icon="['fab', 'youtube']" size="2x" class="mb-1"></Icon>
      <div>
        {{ $t('videoPreviewMessage', { type: 'youtube' }) }}
      </div>
    </template>
    <Youtube
      v-else
      ignore-consent
      :value="value"
      class="kvass-media-types-youtube-preview__preview"
    />
  </div>
</template>

<script>
import Youtube from '@kvass/media-render/Types/Youtube'
import Icon from '@kvass/vue2-icon'

export default {
  props: {
    value: {
      type: Object,
      default: '',
    },
    isValid: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Youtube,
    Icon,
  },
}
</script>

<style lang="scss">
.kvass-media-types-youtube-preview {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 0.9em;
  flex-grow: 1;
  padding: 1rem;
  background: transparent;
  height: 320px;

  &__preview {
    width: 100%;
    height: inherit;
    position: relative;
  }

  svg {
    color: #fe0002;
  }
}

.kvass-media-type-selector__modal .kvass-card {
  width: 100%;
  max-width: 700px;
}
</style>
